export default "__VITE_ASSET__BuePs3bG__"